import clsx from "clsx";
import type { PropsWithChildren } from "react";

const GridLayoutSidebar = ({
	children,
	className,
}: PropsWithChildren<{ className?: string }>) => {
	return (
		<div
			className={clsx(
				"relative mx-auto laptop:max-w-sm max-w-xl flex-1 overflow-y-scroll laptop:border-r bg-white laptop:p-4 p-3 dark:border-slate-700 dark:bg-slate-800",
				className,
			)}
		>
			{children}
		</div>
	);
};

export default GridLayoutSidebar;
